
































































import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { AuditPackage } from '~/models/audit/package'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import AuditPackageOptionsList from '~/components/shared/classified/audits/AuditPackageOptionsList.vue'
import { capitalizeSentences } from '~/utils/string'
import AuditPackagePerks from '~/components/shared/classified/audits/AuditPackagePerks.vue'

export default defineComponent({
  components: { AuditPackageOptionsList, CPrice, AuditPackagePerks },
  props: {
    package: {
      type: Object as PropType<AuditPackage>,
      required: true
    },
    focused: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(_, { emit }) {
    const packageClicked = () => {
      emit('clicked')
    }
    return { capitalizeSentences, packageClicked }
  }
})
